import ArkLoader from '@src/js/common/ark-extensions';
import recordConfig from './component-config';
import { IExtension } from '@tencent/ark-extensions';
import { PadType } from '@tencent/docs-mime-types';

/**
 * 版本管理组件展示
 */
export async function showComponentRecordContent(options: any): Promise<IExtension> {
    const arkService = ArkLoader.extensionService;
    await arkService.scanAndHandleExtensions([recordConfig]);
    const componentRecord = await ArkLoader.extensionService.getExtension(recordConfig.name);
    (componentRecord as any).showVersionAndEditRecordPanel({
        docInfo: getDocInfoParams(),
        ...options,
    });
    return componentRecord;
}

/**
 * 版本管理组件关闭
 */
export async function hideComponentRecordContent(): Promise<IExtension> {
    const arkService = ArkLoader.extensionService;
    await arkService.scanAndHandleExtensions([recordConfig]);
    const componentRecord = await ArkLoader.extensionService.getExtension(recordConfig.name);
    (componentRecord as any).hide();
    return componentRecord;
}

/**
 * 版本管理组件保存版本
 */
export async function saveComponentRevision(showRevisionPanel: any): Promise<IExtension> {
    const arkService = ArkLoader.extensionService;
    await arkService.scanAndHandleExtensions([recordConfig]);
    const componentRecord = await ArkLoader.extensionService.getExtension(recordConfig.name);
    (componentRecord as any).commitVersion({
        docInfo: getDocInfoParams(),
        onOpenVersionPanel: () => {
            showRevisionPanel();
        },
    });
    return componentRecord;
}

const getDocInfoParams = () => ({
    padId: window.clientVars?.padId || '',
    domainId: window.clientVars?.domainId || '',
    padType: PadType.Slide,
    mimeType: `application/vnd.tdocs-apps.${PadType.Slide}`,
    title: window.clientVars?.padTitle || '',
    canEdit: true,
});
